import React, { useState, useEffect } from "react";
import { Button, TextField, Grid, Tooltip, IconButton } from "@mui/material";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { TextValidator } from "react-material-ui-form-validator";
import designForGstr2bRep from "../GSTR-2A_Repository/Gst2aRepository.module.css";
import axios from "../../../../axios-order";
import moment from "moment";
import DownloadIcon from "@mui/icons-material/Download";
import DatePicker from '../GSTR-2A_Repository/DatePicker';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import { ValidatorForm } from "react-material-ui-form-validator";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import ToggleSwitch from "../../../../components/ui/ToggleSwitch/ToggleSwitch";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import SelectField from "../../../../components/ui/basicSelectInput";

const apiUrl = process.env.REACT_APP_BACKEND_BASE_URL;

const dateFormat = (value) => {
  if (!value) {
    return "";
  }
  const current_date = new Date(value);
  const yy = current_date.getFullYear().toString();
  const mm = (current_date.getMonth() + 1).toString();
  const dd = current_date.getDate().toString();
  return `${dd}/${mm}/${yy}`;
};

export default function Gstr8ARepository() {
  const [openAndCloseModel, setOpenAndCloseModel] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileDataToUpload, setFileDataToUpload] = useState("");
  const [showSuccessOnly, setShowSuccessOnly] = useState(false);
  const [yearFromArr, setFromYearArr] = useState([]);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState('');
  const history = useHistory();

  //...............For Error Message..........................
  const [colorForErrorMessage, setColorForErrorMessage] = useState("red");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageVisibilityStyle, setErrorMessageVisibilityStyle] =
    useState("hidden");
  const [errorMessageDisplayStyle, setErrorMessageDisplayStyle] =
    useState("none");

  //...........Record From Get Api.................
  const [recordForTable, setRecordForTable] = useState([]);
  const [recordForTableSearch, setRecordForTableSearch] = useState([]);

  const [loaderForTable, setLoaderForTable] = useState(false);
  const [loading, setLoading] = useState(false);

  // ..............this is Auto GSTR Download
  const [fromMonthYearDisplay, setFromMonthYearDisplay] = useState(null)
  const [fromToYearDisplay, setFromToYearDisplay] = useState(null)
  const [next, setNext] = useState(false)
  const [responseMessage, setResponseMessage] = useState("");

  //   Gstr Status code begin
  const [status, setStatus] = useState(false);
  const [data, setData] = useState([]);
  const [errorMessages, setErrorMessages] = useState('');
  const [showBoxWrapper, setShowBoxWrapper] = useState(false);
  const [responseData, setResponseData] = useState("");
  const [displayResponse, setDisplayResponse] = useState(false);
  const [taskId, setTaskId] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  //Snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isPaymentRequired, setIsPaymentRequired] = useState(true);

  useEffect(() => {
    // Call the additional API only when taskId is available
    if (taskId) {
      const additionalApiUrl = `/autodownloadapi/${taskId}`;
      axios.get(additionalApiUrl)
        .then(response => {
          console.log('Additional API response:', response.data);
        })
        .catch(error => {
          console.error('Error calling additional API:', error);
        });
    }
  }, [taskId]);


  const getStatusStyleAndMessage = (status, failReason) => {
    const lowerStatus = (status || "").toLowerCase();

    if (lowerStatus === "pass" || lowerStatus === "success") {
      return {
        iconColor: "#4caf50",          // green (Material-UI success green)
        severity: "success",
        message: "Data uploaded successfully",
        isClickable: true,
      };
    }

    if (
      lowerStatus === "failed" ||
      lowerStatus === "fail" ||
      lowerStatus.includes("fail")
    ) {
      return {
        iconColor: "#f44336",          // red (Material-UI error red)
        severity: "error",
        message: failReason || "Upload failed – unknown reason",
        isClickable: !!failReason,     // only show pointer if there's actually a reason
      };
    }

    if (lowerStatus === "initiated" || lowerStatus === "in progress") {
      return {
        iconColor: "#ff9800",          // orange (warning)
        severity: "warning",
        message: `Upload is ${lowerStatus.toLowerCase()}`,
        isClickable: true,
      };
    }

    // fallback / unknown
    return {
      iconColor: "#9e9e9e",            // gray
      severity: "info",
      message: "Unknown upload status",
      isClickable: false,
    };
  };

  const setFromYearValues = () => {
    const currentYear = new Date().getFullYear();
    const yearsList = Array.from({ length: 10 }, (_, index) => {
      const year = currentYear - index;
      return `${year}-${(year + 1).toString().slice(-2)}`;
    });
    let yearArr = yearsList.map((year, index) => ({
      id: index + 1,
      year,
      choice_id: year,
      choice_name: year,
    }));
    setFromYearArr(yearArr);
    console.log('yearArr..........', yearArr);
  };

  const checkPaymentRequired = async () => {
  try {
    const { data } = await axios.get(
      `/check_gstr8a_auto_download_payment_required/${localStorage.getItem("business_entity_id")}`,
    );
    setIsPaymentRequired(data?.is_payment_required);
  } catch (err) {
    console.error("Failed to check payment required:", err);
  }
};

  useEffect(() => {
    // Call the additional API only when taskId is available
    setFromYearValues()
  }, []);

  const handleButtonClick = () => {
    setShowBoxWrapper(!showBoxWrapper);
  };

  const handleBackNavigation = () => {
    history.push("/repoCards");
  };

  // Function to open Snackbar
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarOpen(true);
    setSnackbarSeverity(severity);
    setResponseMessage(message);
  };

  // Function to close Snackbar
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSnackbarSeverity("success");
    setResponseMessage("");
  };

  const handleDownload = (gst_task_id, business_entity_id) => {
    const url = `${apiUrl}/mydemo/gstDownload/gstrtaskdownload/`;
    const requestData = new FormData();
    requestData.append('task_id', gst_task_id);
    requestData.append('entity_id', business_entity_id);

    axios.post(url, requestData)
      .then(response => {
        console.log('API response:', response.data);
        setResponseData(response.data)
        setDisplayResponse(true);
        const autoTaskId = extractAutoTaskId(response.data);
        if (autoTaskId) {
          setTaskId(autoTaskId);
        }

        setTimeout(() => {
          setResponseData('');
          setDisplayResponse(false);
        }, 10000);
      })
      .catch(error => {
        console.error('Error sending data:', error);
      });
  };

  const extractAutoTaskId = (response) => {
    const autoTaskIdPattern = /Auto Task id :(\d+)/;
    const match = response.match(autoTaskIdPattern);
    return match ? match[1] : null;
  };

  const handle = (gst_task_id, business_entity_id) => {
    const url = `${apiUrl}/mydemo/gstDownload/gstrtaskstatus/`;
    const requestData = new FormData();
    requestData.append('task_id', gst_task_id);
    requestData.append('entity_id', business_entity_id);

    axios.post(url, requestData)
      .then(response => {
        console.log('API response:', response.data);
      })
      .catch(error => {
        console.error('Error sending data:', error);
        if (error.response && error.response.status !== 200) {
          setErrorMessages('An error occurred.');
        }
      });
  };

  const business_entity_id = localStorage.getItem('business_entity_id');

  const handleClick = (first_col, second_col) => {
    axios.post(`${apiUrl}/table/`, { first_col, second_col })
      .then(response => {
        console.log('Data sent to backend:', response.data);
      })
      .catch(error => {
        console.error('Error sending data:', error);
      });
  };

  const handleChange = (event) => {
    setNext(event.target.checked);
  };

  const handleToastifyNotification = (uploadFailReason) => {
    // For failures, use 'error' severity so snackbar shows red
    handleSnackbarOpen(uploadFailReason, 'error');
    // Or if your snackbar supports 'warning', use that
  };

  //functionFromMonth and DatePicker
  const inputHandlerFromPicker = (v) => {
    setFromMonthYearDisplay(v)
    const formattedDate = moment(v).format("MMYYYY");
    setFromMonthYearDisplay(formattedDate);
    console.log(formattedDate)
  }

  //Function for the Date and Month Picker
  const inputHandlerToPicker = (v) => {
    setFromToYearDisplay(v)
    const formatDate = moment(v).format("MMYYYY");
    setFromToYearDisplay(formatDate)
    console.log(formatDate)
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setResponseMessage("");
    }, 7000);
    return () => clearTimeout(timer);
  }, [responseMessage]);

  /// This changes for the handleGstr8A 
  const handleGSTR1Download = () => {
    setIsSubmitting(true);

    const gstin = localStorage.getItem('gst');
    const business_entity_id = localStorage.getItem('business_entity_id');

    if (isPaymentRequired) {
      const orderItems = [
        {
          plan_name: "GSTR-8A Auto Download",
          plan_id: "0",
          description: "GSTR8A_AUTO_DOWNLOAD",
          features: [
            { particulars: "GSTR-8A Auto Download", qty: 1, amount: 20.00 },
          ],
          amount: {
            sub_total: 20.00,
            GST_charges: 3.60,
            total: 23.60,
          },
          addOn: [],
          gstin: gstin,
          ret_period: selectedFinancialYear,
        },
      ];
      setIsSubmitting(false);
      history.push("/orderSummary", orderItems);
    } else {
      callGstr8aDownload(gstin, selectedFinancialYear)
        .finally(() => setIsSubmitting(false));
    }
  };

  const callGstr8aDownload = (gstin, ret_period) => {
    const payload = { gstin, ret_period };

    return axios.post(`/gstr8a_auto_download_passthrough`, payload)
      .then(response => {
        try {
          const responseData = response.data;

          if (responseData.status === false) {
            handleSnackbarOpen(responseData.message, 'error');
          } else {
            handleSnackbarOpen(
              responseData.message || 'Request processed successfully',
              'success'
            );
          }
        } catch (error) {
          console.log(error);
          handleSnackbarOpen('Unexpected Error.', 'error');
        }
      })
      .catch(error => {
        console.log(error);
        handleSnackbarOpen('Unexpected Error.', 'error');
      });
  };

  //.............Open And Close Event For Model.............
  const handleOpenAndClose = () => {
    setOpenAndCloseModel(!openAndCloseModel);
    functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
    setFileDataToUpload("");
    setFileName("");
  };

  const fileUploadCancelButtonHandler = () => {
    functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
    setFileDataToUpload("");
    setFileName("");
  };

  //.......Handle Search....................
  const handleSearch = (e) => {
    let Search = e.target.value.trim();
    const searchName = recordForTableSearch.filter((v) => {
      return (
        String(v.gstr_upload_file_type)
          .toLowerCase()
          .indexOf(Search.toLowerCase()) >= 0 ||
        String(v.financial_year).toLowerCase().indexOf(Search.toLowerCase()) >=
        0 ||
        String(v.generation_date).toLowerCase().indexOf(Search.toLowerCase()) >=
        0 ||
        String(moment(v.tax_period, "MMYYYY").format("MM-YYYY")).indexOf(
          Search
        ) >= 0 ||
        String(
          moment(v.upload_date, "YYYY-MM-DD").format("DD-MM-YYYY")
        ).indexOf(Search) >= 0
      );
    });
    setRecordForTable(searchName);
  };

  //........For Succesfull Message..................
  const functionForSuccesfullMessageAndErroeMessage = (
    color,
    visible,
    display,
    message
  ) => {
    setColorForErrorMessage(color);
    setErrorMessageVisibilityStyle(visible);
    setErrorMessageDisplayStyle(display);
    setErrorMessage(message);
  };

  //.............File Upload Data Saving in useState..............
  const handleFileUpload = (e) => {
    functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
    if (e.target.files.length) {
      const file_data = e.target.files[0];
      let fileName = file_data.name;
      setFileName(fileName);
      const reader = new FileReader();
      reader.readAsDataURL(file_data);
      reader.onload = function () {
        let file_value = reader.result;
        setFileDataToUpload(file_value);
      };
      e.target.value = null;
    }
  };

  //......Submit Event For File Upload in axios.......
  const handleSubmitEvent = (e) => {
    if (fileName === "") {
      handleSnackbarOpen("Please Upload The File!", "error");
      return;
    }

    setLoading(true);
    axios
      .post(`/gstr8A_upload`, {
        file: fileDataToUpload,
        gstin: localStorage.getItem("gst"),
        document_name: fileName
      })
      .then((res) => {
        if (res.data && res.data.status === true) {
          functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
          getApiForGst2bRepository();
          handleSnackbarOpen("File uploaded successfully", "success");
          resetFileUpload();
        } else {
          handleSnackbarOpen(res.data.message, "error");
        }
      })
      .catch((error) => {
        handleSnackbarOpen(error.response.data.message, "error");
        resetFileUpload();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const resetFileUpload = () => {
    setFileDataToUpload(null);
    setFileName("");
  };

  //.......................Get Api For Gst................
  const getApiForGst2bRepository = () => {
    setLoaderForTable(true);
    axios
      .get(`/gstr8A_repository/${localStorage.getItem("gst")}`)
      .then((res) => {
        if (res.data.status === true) {
          setLoaderForTable(false);
          setRecordForTable(res.data.records);
          setRecordForTableSearch(res.data.records);
        } else {
          setLoaderForTable(false);
          alert(res.data.message);
        }
      })
      .catch(() => setLoaderForTable(false));
  };

  const newReconModalClose = () => {
    setFileName("");
    setFromMonthYearDisplay("");
    setFromToYearDisplay("");
    setFileDataToUpload("");
    setErrorMessage("");
    functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
  };

  useEffect(() => {
    getApiForGst2bRepository();
    checkPaymentRequired();
  }, []);

  return (
    <React.Fragment>
      <div style={{ padding: "15px 20px", backgroundColor: "#f5f5f5" }}>
        <Tooltip title="Back" arrow>
          <IconButton
            onClick={handleBackNavigation}
            sx={{
              borderRadius: '50%',
              padding: '6px',
              color: '#263238',
              fontSize: '20px',
              backgroundColor: '#ffffff',
              height: '36px',
              width: '36px',
              '&:hover': {
                backgroundColor: '#455a64',
                color: '#ffffff',
              },
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
              transition: 'background-color 0.3s ease',
            }}
          >
            <ArrowBackIcon sx={{ fontSize: '20px' }} />
          </IconButton>
        </Tooltip>
      </div>
      <BoxWrapper
        boxTitle={
          <div style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "100%",
            paddingRight: "20px",
            position: "relative"
          }}>
            <span style={{ fontWeight: 600, color: "#000" }}>
              GSTR-8A Repository
            </span>
            <span style={{ fontWeight: 600, position: "absolute", left: "45%", transform: "translateX(-50%)" }}>
              GSTR-8A Auto Download
            </span>
          </div>
        }
      >
        <ValidatorForm
          onSubmit={(e) => {
            e.preventDefault();
            if (fileName && fileDataToUpload) {
              handleSubmitEvent(e);
            } else if (selectedFinancialYear) {
              handleGSTR1Download();
            } else {
              handleSnackbarOpen('Please select a financial year or upload a file.', 'warning');
            }
          }}
          // onSubmit={(e) => {
          //   e.preventDefault();
          //   if (fileName && fileDataToUpload) {
          //     handleSubmitEvent(e);
          //   } else if (fromMonthYearDisplay && fromToYearDisplay) {
          //     handleGSTR1Download();
          //   }
          // }}
          onError={(errors) => console.log(errors)}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '40px' }}>
              {/* Upload Button */}
              <div style={{ minWidth: '100px' }}>
                <label
                  className="button-primary"
                  style={{
                    width: "100%",
                    textAlign: "center",
                    cursor: fromMonthYearDisplay ? "not-allowed" : "pointer",
                    padding: "8px",
                    display: 'block',
                    opacity: fromMonthYearDisplay ? 0.5 : 1,
                    pointerEvents: fromMonthYearDisplay ? 'none' : 'auto'
                  }}
                >
                  Upload
                  <input
                    type="file"
                    accept=".xlsx,.json,.zip"
                    onChange={handleFileUpload}
                    hidden
                    disabled={!!fromMonthYearDisplay}
                  />
                </label>
              </div>

              {/* File name field */}
              <div style={{ flex: '0 0 350px' }}>
                <TextField
                  placeholder="Choose file"
                  value={fileName}
                  variant="standard"
                  fullWidth
                  disabled={!!fromMonthYearDisplay}
                  style={{ opacity: fromMonthYearDisplay ? 0.5 : 1 }}
                  inputProps={{
                    readOnly: true,
                  }}
                />
              </div>

              {/* From Date Picker */}
              <div style={{ flex: '0 0 300px', opacity: fileName ? 0.5 : 1 }}>
                <Grid container spacing={2}>
                  <Grid item sm>
                    <SelectField
                      SelectLabel="Financial year"
                      // validator={["required"]}
                      requiredField="*"
                      // errorMsg={["This field is required"]}
                      choice_id="year"
                      choice_name="year"
                      choices={yearFromArr}
                      name="financial_year"
                      value={selectedFinancialYear}                     // ← controlled
                      textOnchangeFunction={(e) => {
                        setSelectedFinancialYear(e.target.value);       // ← update state
                      }}
                    />
                  </Grid>
                </Grid>

              </div>


              {/* Button Group */}
              <div style={{ display: 'flex', gap: '5px', marginLeft: '-25px' }}>
                <div style={{ minWidth: '100px' }}>
                  <button
                    className="button-primary"
                    type="submit"
                    style={{ width: '100%', padding: '8px' }}
                    disabled={loading || isSubmitting}
                  >
                    {(loading || isSubmitting) ? 'Submitting...' : 'Submit'}
                  </button>
                </div>

                <div style={{ minWidth: '100px' }}>
                  <button
                    type="button"
                    className="button-outlined-secondary"
                    onClick={newReconModalClose}
                    style={{ width: '100%', padding: '8px' }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ValidatorForm>
        {errorMessage && (
          <p style={{ color: "red", marginTop: "10px" }}>{errorMessage}</p>
        )}
      </BoxWrapper>

      {/*..................Table.......................*/}
      <BoxWrapper
        boxTitle="History"
        enableSearchInput={true}
        searchInputPlaceholder="Search..."
        searchInputOnchange={handleSearch}
        enableAddButton={true}
        addButtonLabel="Refresh"
        addButtonHandlerFn={getApiForGst2bRepository}
      >
        <div className="responsive-table">
          <table className="custome-table">
            <thead>
              <tr>
                <th>GSTR8A UPLOAD FILE TYPE</th>
                {/* <th>TAX PERIOD</th> */}
                <th>FINANCIAL YEAR</th>
                <th>GENERATION DATE</th>
                <th>UPLOAD DATE</th>
                <th>STATUS</th>
                <th>
                  <label>
                    <input
                      type="checkbox"
                      checked={showSuccessOnly}
                      onChange={() => setShowSuccessOnly(!showSuccessOnly)}
                    />
                    Show Success Only
                  </label>
                </th>
              </tr>
            </thead>
            <tbody>
              {recordForTable.map((v, index) => {
                const {
                  iconColor,
                  severity,
                  message,
                  isClickable,
                } = getStatusStyleAndMessage(v.upload_status, v.upload_fail_reason);

                // Optional: skip non-success rows if filter is active
                if (showSuccessOnly && !["Pass", "Success"].includes(v.upload_status)) {
                  return null;
                }

                return (
                  <tr key={index}>
                    <td style={{ textTransform: "capitalize" }}>{v.gstr_upload_file_type}</td>
                    <td>{v.financial_year !== "None" ? v.financial_year : ""}</td>
                    <td style={{ textTransform: "capitalize" }}>
                      {v.generation_date ? dateFormat(v.generation_date) : ""}
                    </td>
                    <td style={{ textTransform: "capitalize" }}>
                      {v.upload_date !== "None" ? moment(v.upload_date).format("DD-MM-YYYY HH:mm:ss") : ""}
                    </td>

                    {/* Status text – colored to match icon */}
                    <td style={{ color: iconColor, fontWeight: 500 }}>
                      {v.upload_status}
                    </td>

                    {/* Eye icon column */}
                    <td>
                      <div
                        style={{
                          cursor: isClickable ? "pointer" : "default",
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          if (isClickable) {
                            handleSnackbarOpen(message, severity);
                          }
                        }}
                        title={message} // hover tooltip – very useful
                      >
                        <VisibilityOutlinedIcon
                          className="action-icon-button showIcon"
                          style={{ color: iconColor }}
                        />
                      </div>
                    </td>
                  </tr>
                );
              })}

              {loaderForTable ? (
                <tr>
                  <td colSpan={6} style={{ color: "black", textAlign: "center", fontWeight: "bold" }}>
                    Loading… Please wait
                  </td>
                </tr>
              ) : recordForTable.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ color: "red", textAlign: "center" }}>
                    No Data Found!
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </BoxWrapper>

      {responseData && (
        <div>
          <p style={{ fontSize: '20px', color: 'green' }}>DOWNLOADED GSTR DATA</p>
          <p>{responseData}</p>
        </div>
      )}

      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        style={{ maxWidth: '25%' }}
      >
        <MuiAlert
          elevation={2}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
        >
          {responseMessage}
        </MuiAlert>
      </Snackbar>

    </React.Fragment>
  );
}